import yup from 'src/libraries/validator.library';

export const CNDDistrictSchema = yup
  .object({
    cndDistrictId: yup.number(),
    cndDistrict: yup.string().required(),
    dist3: yup.string().required(),
  })
  .defined();

export const CNDDistrictFormSchema = yup
  .object({
    cndDistrictId: yup.number(),
    cndDistrict: yup.string().required(),
    dist3: yup.string().required(),
  })
  .defined();

export const CNDDistrictListPayloadSchema = yup
  .object({
    count: yup.number().defined(),
    rows: yup.array().of(CNDDistrictSchema).defined(),
  })
  .defined();

export type ICNDDistrict = yup.InferType<typeof CNDDistrictSchema>;
export type ICNDDistrictForm = yup.InferType<typeof CNDDistrictFormSchema>;
